var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.75 24.4995L83.6943 5.56279C90.5775 2.88602 98 7.96354 98 15.3488V72.9315C98 80.0984 90.9787 85.159 84.1796 82.8927L36.75 66.4995V24.4995ZM21 24.4999H28V62.9999V66.4999V73.4999C28 77.3659 31.134 80.4999 35 80.4999H38.5C42.366 80.4999 45.5 83.6339 45.5 87.4999C45.5 91.3659 42.366 94.4999 38.5 94.4999H35C23.402 94.4999 14 85.0979 14 73.4999V65.3049C5.84365 62.4221 0 54.6434 0 45.4999C0 33.9019 9.40202 24.4999 21 24.4999Z",
    fill: "#096F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.12921dc24e5dfb9220e064012667fbfc.svg";
export { ForwardRef as ReactComponent };